<script setup lang="ts"></script>

<template>
  <UtilsSection
    container-class="max-w-screen-xl"
    id="video-presentation"
    class="bg-white"
  >
    <div
      class="grid items-center gap-10 lg:grid-cols-2 lg:gap-16"
    >
      <div class="text-center lg:text-left" data-aos="fade-right">
        <p
          class="text-[#27C9F4] uppercase tracking-[0.3em] text-xs font-medium mb-4"
        >
          {{ $t("video.eyebrow") }}
        </p>
        <UtilsTitle as="h2" class="text-3xl md:text-5xl">
          {{ $t("video.title") }}
        </UtilsTitle>
        <UtilsSubtitle class="mt-4 text-gray-500 text-lg max-w-md mx-auto lg:mx-0">
          {{ $t("video.description") }}
        </UtilsSubtitle>
      </div>

      <div
        class="relative mx-auto w-full max-w-[320px] sm:max-w-[360px] lg:max-w-[380px] lg:ml-auto"
        data-aos="fade-left"
      >
        <div
          class="absolute -inset-4 rounded-[2rem] bg-[#27C9F4]/10 blur-2xl"
        />
        <div
          class="relative overflow-hidden rounded-[1.75rem] bg-[#070d18] shadow-2xl shadow-[#070d18]/25 ring-1 ring-black/10"
        >
          <video
            class="aspect-[9/16] w-full object-cover bg-[#070d18]"
            controls
            playsinline
            preload="metadata"
            poster="/images/journey/milao-navigli-poster.jpg"
          >
            <source src="/videos/milao-navigli-vertical.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  </UtilsSection>
</template>
